import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrArrowLeftIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M10.7784 14.7857C11.0739 14.5001 11.0739 14.037 10.7783 13.7514L4.827 8.00036L10.7783 2.24855C11.0739 1.96293 11.0739 1.49984 10.7783 1.21422C10.4828 0.928594 10.0037 0.928594 9.70813 1.21422L3.22165 7.48322C3.07972 7.62039 2.99999 7.80643 3 8.00041C3.00001 8.1944 3.07975 8.38043 3.22168 8.51759L9.70817 14.7858C10.0037 15.0714 10.4829 15.0714 10.7784 14.7857Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrArrowLeftIconComponent;
